import { createActionGroup, emptyProps } from '@ngrx/store';

export const GlobalActions = createActionGroup({
    source: 'Toggle mobile menu',
    events: {
        'Toggle Mobile Menu': emptyProps(),
        'Toggle Edu Login Registration': emptyProps(),
    },
});
